import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageLocationPricingBaseComponent } from '@luggagehero/features/shop-manager/base/storage-location-pricing.base-component';
import { ProductService } from '@luggagehero/services/storage-manager/product.service';
import { SharedNotificationService } from '@luggagehero/shared/services/notification';
import { SharedShopsService } from '@luggagehero/shared/services/shops';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lh-storage-location-pricing',
  templateUrl: './storage-location-pricing.component.html',
  styleUrls: ['./storage-location-pricing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StorageLocationPricingComponent extends StorageLocationPricingBaseComponent {
  constructor(
    shopService: SharedShopsService,
    productService: ProductService,
    notify: SharedNotificationService,
    router: Router,
    route: ActivatedRoute,
    translate: TranslateService,
    cd: ChangeDetectorRef,
  ) {
    super(shopService, productService, notify, router, route, translate, cd);
  }
}
